import { render } from "./StateComparison.vue?vue&type=template&id=0de4cdc4&scoped=true"
import script from "./StateComparison.vue?vue&type=script&lang=js"
export * from "./StateComparison.vue?vue&type=script&lang=js"

import "./StateComparison.vue?vue&type=style&index=0&id=0de4cdc4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0de4cdc4"]])

export default __exports__